
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forex",
      function () {
        return require("private-next-pages/forex/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forex"])
      });
    }
  